/**
 * Onde a "Consulta SQL" guarda as linhas para os próximos blocos.
 *
 * O serviço só precisa de um nome (`resultado_em`) que não se repita no mesmo
 * fluxo: duas consultas no mesmo nome, e a segunda apaga a primeira. A pessoa
 * não escreve esse nome (memória "automações mastigadas"): escolhe numa lista
 * fixa, e o bloco novo já nasce com o primeiro que está livre.
 */

import type { AutomacaoDaApi } from '@cliqcrm/contracts';

type Grafo = NonNullable<AutomacaoDaApi['grafo']>;

export const RESULTADOS_DA_CONSULTA: readonly { valor: string; rotulo: string }[] = [
  { valor: 'linhas', rotulo: 'Linhas da 1ª consulta' },
  { valor: 'linhas_2', rotulo: 'Linhas da 2ª consulta' },
  { valor: 'linhas_3', rotulo: 'Linhas da 3ª consulta' },
  { valor: 'linhas_4', rotulo: 'Linhas da 4ª consulta' },
  { valor: 'linhas_5', rotulo: 'Linhas da 5ª consulta' },
];

/** O nome que a pessoa lê; o de uma automação antiga, fora da lista, aparece como está. */
export function rotuloDoResultado(valor: string): string {
  return RESULTADOS_DA_CONSULTA.find((r) => r.valor === valor)?.rotulo ?? valor;
}

/** Os resultados que as outras consultas do fluxo já usam. */
export function resultadosUsados(grafo: Grafo, menosOBloco?: string): Set<string> {
  return new Set(
    grafo.nos.flatMap((n) =>
      n.tipo === 'consulta_sql' && n.id !== menosOBloco ? [n.resultado_em] : [],
    ),
  );
}

/** O primeiro resultado que nenhuma consulta do fluxo usa; todos usados, o primeiro. */
export function proximoResultadoLivre(grafo: Grafo, menosOBloco?: string): string {
  const usados = resultadosUsados(grafo, menosOBloco);
  return (RESULTADOS_DA_CONSULTA.find((r) => !usados.has(r.valor)) ?? RESULTADOS_DA_CONSULTA[0]!)
    .valor;
}
